var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "app full-screen",
    attrs: {
      "data-app": "app"
    }
  }, [_c('TheCosmicApplication', {
    attrs: {
      "route-configs": _vm.routesForThisContext
    },
    on: {
      "show_application_change_log": function ($event) {
        _vm.showModalApplicationChangeLog = true;
      }
    }
  }, [_c('template', {
    slot: "create_menu_items"
  }, [_vm.shouldShowCreateMenuDeliveryOrder ? _c('c-menu-item', {
    attrs: {
      "href": `/delivery_orders/create?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.DocumentType.DELIVERY_ORDER],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Create a Delivery Order "), _c('small')])], 1)]) : _vm._e()], 1), _c('template', {
    slot: "nav_bar_logo"
  }, [_c('router-link', {
    staticClass: "delinkify",
    attrs: {
      "to": `/?ctx=${_vm.currentUserActiveSupportContext}`,
      "tooltip": "COSMIC Logistics Home"
    }
  }, [_c('img', {
    attrs: {
      "height": "36px",
      "src": _vm.cosmicLogisticsLogoSrc,
      "alt": "COSMIC Logistics logo"
    }
  })])], 1), _c('template', {
    slot: "side_menu_items"
  }, [_vm.shouldShowSideNavDeliveryOrders ? _c('c-menu-item', {
    attrs: {
      "href": `/delivery_orders/search?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.DocumentType.DELIVERY_ORDER],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v("Delivery orders")])], 1)]) : _vm._e(), _vm.shouldShowSideNavDeliveryMatrix ? _c('c-menu-item', {
    attrs: {
      "href": `/delivery_matrix?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons[_vm.EntityType.DELIVERY_MATRIX_ITEM],
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v("Delivery matrix")])], 1)]) : _vm._e(), _vm.shouldShowSideNavAllocationMatrix ? _c('c-menu-item', {
    attrs: {
      "href": `/allocation_matrix?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "align-items": "center",
      "display": "flex",
      "justify-content": "center",
      "width": "38px"
    }
  }, [_c('c-icon-fa', {
    staticStyle: {
      "position": "absolute",
      "left": "-12px"
    },
    attrs: {
      "icon": "fa-regular fa-bracket-square",
      "icon-size": "20px",
      "icon-color": "var(--cosmic-text)"
    },
    domProps: {
      "fixedWidth": false
    }
  }), _c('c-icon-fa', {
    staticStyle: {
      "position": "absolute",
      "left": "3px"
    },
    attrs: {
      "icon": "fa-duotone fa-user-astronaut",
      "icon-size": "15px",
      "icon-color": "var(--v-item_instances-base)"
    },
    domProps: {
      "fixedWidth": false
    }
  }), _c('c-icon-fa', {
    staticStyle: {
      "position": "absolute",
      "left": "12px"
    },
    attrs: {
      "icon": "fa-regular fa-bracket-square-right",
      "icon-size": "20px",
      "icon-color": "var(--cosmic-text)"
    },
    domProps: {
      "fixedWidth": false
    }
  })], 1), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v("Allocation matrix")])])]) : _vm._e(), _vm.shouldShowSideNavItemListings ? _c('c-menu-item', {
    attrs: {
      "href": `/item_listings?ctx=${_vm.currentUserActiveSupportContext}`
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('div', {
    staticStyle: {
      "width": "38px"
    }
  }, [_c('IconAutoHardwareList')], 1), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v("Item listings")])])]) : _vm._e()], 1), _c('template', {
    slot: "reporting_menu_items"
  }, _vm._l(_vm.routesForThisContext, function (route, index) {
    return _c('c-menu-item', {
      key: index,
      attrs: {
        "href": `${route.path}?ctx=${_vm.currentUserActiveSupportContext}`
      }
    }, [_c('div', {
      staticClass: "text-truncate c-flex align-items-center no-gap"
    }, [_c('c-icon-fa', {
      staticClass: "mr-2",
      attrs: {
        "icon-size": "22px",
        "icon": index <= 9 ? `fa-duotone fa-solid fa-${index}` : _vm.$icons.application_reporting,
        "icon-color": "var(--cosmic-text)"
      }
    }), _c('div', {
      staticClass: "text-truncate c-flex column no-gap"
    }, [_vm._v(" " + _vm._s(route.meta.displayName) + " "), _c('small', [_vm._v(_vm._s(route.meta.description))])])], 1)]);
  }), 1)], 2), _vm.showModalApplicationChangeLog ? _c('ModalChangeLog', {
    on: {
      "modal-close": _vm.resetModals
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };